module.exports = __webpack_public_path__ + "img/folder-secure-alt.56125191.svg";